/**
 * Engagement event tracker.
 * Provides Nova.track(event, properties) — scrubs PII from properties,
 * then queues the event for batched writing to CloudWatch.
 */

import type { EngagementEvent, LogEvent } from '../types';
import { scrubPII, scrubObject } from '../pii';

export type TrackCallback = (event: LogEvent) => void;

export class EngagementTracker {
  private callback: TrackCallback;

  constructor(callback: TrackCallback) {
    this.callback = callback;
  }

  /**
   * Track an engagement event.
   * Properties are deep-scrubbed for PII before queuing.
   */
  track(event: string, properties?: Record<string, unknown>): void {
    const scrubbedEvent = scrubPII(event);
    const scrubbedProperties = properties ? scrubObject(properties) : {};

    const engagementEvent: EngagementEvent = {
      event: scrubbedEvent,
      properties: scrubbedProperties as Record<string, unknown>,
      timestamp: new Date().toISOString(),
    };

    this.callback({
      stream: 'engagement',
      data: engagementEvent,
    });
  }
}
